<template>
  <div class="inner-height custom-bg fixed overflow-auto top-0 bottom-0 left-0 right-0 z-10">
    <div class="relative h-full">
      <div
        class="fixed z-20 text-white bg-zt-primary-200 flex w-full document--header items-center px-6"
      >
        <!-- <button class="mr-auto text-zt-xl" @click="goBackToLicenses">
          <zt-icon name="angle-left" />
        </button> -->
        <p class="w-full text-center text-zt-lg">
          {{$t('message.LincensesApprovalPendingComponent.header.title')}}
        </p>
      </div>
      <div class="px-4 pt-24 pb-10">
        <div class="w-11/12 mx-auto">
          <div class="mx-auto pb-12 relative h-full" > <!-- style="height: calc(100vh - 206px);" -->
            <div class="mb-6">
              <label class="text-zt-white text-zt-base flex">{{ $t('message.LincensesApprovalPendingComponent.labels.nameLastname') }}</label>
              <label class="text-zt-white text-zt-lg font-bold">{{ request.nombre }} {{ request.apellido }}</label>
            </div>
            <div class="mb-6">
              <label class="text-zt-white text-zt-base flex">{{ $t('message.LincensesApprovalPendingComponent.labels.licenseType') }}</label>
              <label class="text-zt-white text-zt-lg font-bold">{{ request.tipo_licencia }}</label>
            </div>
            <div class="mb-6">
              <label class="text-zt-white text-zt-base flex">{{ $t('message.LincensesHistorySummaryComponent.labels.solicitudeState') }}</label>
              <label class="text-zt-white text-zt-lg font-bold">{{ requestStateMsg }}</label>
            </div>
            <div class="mb-6">
              <label class="text-zt-white text-zt-base flex">{{ $t('message.LincensesApprovalPendingComponent.labels.solicitudeDate') }}</label>
              <label class="text-zt-white text-zt-lg font-bold">{{ request.fecha_creacion | withoutHour }}</label>
            </div>
            <div class="flex flex-wrap mb-6">
              <div class="width-49percent">
                <label class="text-zt-white text-zt-base flex">{{ $t('message.LincensesApprovalPendingComponent.labels.startDate') }}</label>
                <label class="text-zt-white text-zt-lg font-bold">{{ request.fecha_desde }}</label>
              </div>
              <div class="width-49percent with-marginleft">
                <label class="text-zt-white text-zt-base flex">{{ $t('message.LincensesApprovalPendingComponent.labels.reincorporationDate') }}</label>
                <label class="text-zt-white text-zt-lg font-bold">{{ request.fecha_regreso }}</label>
              </div>
            </div>
            <div class="flex flex-wrap mb-6">
              <div class="width-49percent">
                <label class="text-zt-white text-zt-base flex">{{ $t('message.LincensesApprovalPendingComponent.labels.days') }}</label>
                <label class="text-zt-white text-zt-lg font-bold">{{ request.dias }}</label>
              </div>
              <div class="width-49percent with-marginleft">
                <label class="text-zt-white text-zt-base flex">{{ balanceMsg }}</label>
                <label class="text-zt-white text-zt-lg font-bold">{{ balance }}</label>
              </div>
            </div>
            <div class="mb-6">
              <label class="text-zt-white text-zt-base flex">{{ $t('message.LincensesApprovalPendingComponent.labels.daysInThisYear') }}</label>
              <label class="text-zt-white text-zt-lg font-bold">{{ daysInThisYear }}</label>
            </div>
            <div class="mb-2">
              <label class="text-zt-white text-zt-base flex">{{ $t('message.LincensesApprovalPendingComponent.labels.observations') }}</label>
              <p
                v-if="request.observaciones" 
                class="mt-2 mb-4 p-4 text-zt-white text-zt-lg border border-white rounded h-40 overflow-auto"
                v-html="request.observaciones"></p>
            </div>
            <div class="z-20 absolute bottom-0 right-0 left-0">
              <div class="mx-auto w-full">
                <zt-button outlined @click="openSingle('reject')" class="w-5/12 ml-2" data-vs-button="cancel">
                  {{ $t('message.LincensesApprovalPendingComponent.cancelButton') }}
                </zt-button>
                <zt-button @click="openSingle('approve')" class="w-5/12 float-right mr-2" data-vs-button="approve">
                  {{ $t('message.LincensesApprovalPendingComponent.approveButton') }}
                </zt-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <zt-modal
      :active="modalActive"
      @close="modalActive = false"
      max-width="40rem"
    >
      <template slot="modal-header">
        <div
          class="p-4 font-bold text-zt-lg"
        >
          <span>{{ titleModal }}</span>
        </div>
      </template>
      <hr class="w-full" />
      <component
        :is="componentBodyModal"
        :request="thisRequest"
        @close="modalActive = false"
        @refresh-table="goBackToLicenses"
      />
    </zt-modal>
  </div>
</template>

<script>
import Licenses from "@/apiClient/Licenses"
import { mapGetters } from 'vuex'
import moment from "moment"
import Approve from './Approve'
import Reject from './Reject'

export default {
  props: {
    request: {
      type: Object,
      default: {}
    }
  },
  data(){
    return{
      licenses: Licenses,
      balanceMsg: '',
      balance: 0,
      requestStateMsg: '',
      daysInThisYear: 0,
      descriptionLimit: 20,
      entries: [],
      modalActive: false,
      titleModal: '',
      componentBodyModal: '',
      thisRequest: [this.request],
    }
  },
  created(){
    this.licenses = new Licenses()
    //Dias acumulados en el año
    let getYearHistoryByType = () => {
      let year = moment().format("YYYY");
      this.licenses
        .getHistoryByType(
          this.request.id_usuario,
          this.request.id_tipo_licencia
        )
        .then(res => {
          let history = res.data.results.data;
          let diasAcumulados = 0;
          for (let key in history) {
            if (history[key].estado_id === '5') {
              let licenseYear = moment(history[key].fecha_desde, "DD/MM/YYYY").format("YYYY");
              if (licenseYear === year) {
                diasAcumulados += parseFloat(history[key].dias);
              }
            }
          }
          this.daysInThisYear = diasAcumulados;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: this.$t(
              `message.errorReference.${error.response.data.response_v2.code}`
            ),
            showConfirmButton: true,
            confirmButtonText: this.$t("message.settingsComponent.list.okMsg")
          }).then(() => {
            this.$router.push({ name: "licenses" });
          });
        });
    };
    getYearHistoryByType();
    //Saldo disponible
    let getBalance = () => {
      this.licenses
        .getBalanceByTypeAndUser(
          this.request.id_usuario,
          this.request.id_tipo_licencia
        )
        .then(response => {
          if (response.data.results.data[0].show_details == true) {
            this.balanceMsg = this.$t(
              "message.LincensesApprovalPendingComponent.labels.salaryAvailablePostApprove"
            );
          } else {
            this.balanceMsg = this.$t(
              "message.LincensesApprovalPendingComponent.labels.salaryRegistered"
            );
          }
          this.balance = response.data.results.data[0].available;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: this.$t(
              `message.errorReference.${error.response.data.response_v2.code}`
            ),
            showConfirmButton: true,
            confirmButtonText: this.$t("message.settingsComponent.list.okMsg")
          }).then(() => {
            this.$router.push({ name: "licenses" });
          });
        });
    };
    getBalance();
  },
  computed: {
    ...mapGetters({ getUser: 'getUser', getTimerSweetAlert: 'getTimerSweetAlert' }),
  },
  filters: {
    withoutHour: value => {
      return value.split(" ")[0]
    }
  },
  methods: {
    goBackToLicenses(){
      this.$router.push({
        name: "licenses"
      });
    },
    openSingle(to){
      switch (to) {
        case 'approve':
          this.componentBodyModal = Approve
          this.titleModal = this.$t('message.LincensesApprovalPendingComponent.modal.approveTitle')
          this.modalActive = !this.modalActive
          break
        case 'reject':
          this.componentBodyModal = Reject
          this.titleModal = this.$t('message.LincensesApprovalPendingComponent.modal.rejectTitle')
          this.modalActive = !this.modalActive
          break
        default:
          break
      }
    },
  }
}
</script>

<style <style lang="scss" scoped>
.document--header {
  height: 64px;
}
.custom-bg{
  background-color: #898dff;
}
.width-49percent{
  width: 49%;
}
.with-marginleft{
  margin-left: 2%;
}
::v-deep .v-text-field--outline {
  .v-input__slot {
    border: 2px solid rgba(255, 255, 255, 0.87) !important;
  }
  textarea {
    color: white !important;
  }
}
@function vh($quantity) {
  @return calc(var(--vh, 1vh) * #{$quantity});
}
.inner-height {
  height: vh(100);
}
</style>